<template>
  <div class="offers-list">
    <div class="offers-list__header">
      <h1>{{ trans('offer.title') }}</h1>
      <a class="btn btn--primary" :href="urlAddOffer">
        {{ trans('office_offer.create') }}
      </a>
    </div>
    <div class="offers-list-controls__container">
      <div class="row">
        <div class="gr-12">
          <div class="offers-list__controls offers-list-controls">
            <div class="offers-list-controls__filters">
              <StateFilter />
              <AddressFilter class="offers-list-controls__address-filter" />
              <OfferSearchTitle />
              <div v-if="viewMode === OfferListViewMode.mosaic" class="offers-list-controls__sort">
                <OfferSort />
              </div>
            </div>
            <div class="offers-list-controls__view">
              {{ trans('offer.display') }}
              <div class="offers-list-controls__view-toggle">
                <div
                  class="btn"
                  :class="viewMode === OfferListViewMode.mosaic ? 'btn--white' : 'btn--invisible'"
                  @click="viewMode = OfferListViewMode.mosaic"
                >
                  {{ trans('offer.card') }}
                </div>
                <div
                  class="btn"
                  :class="viewMode === OfferListViewMode.list ? 'btn--white' : 'btn--invisible'"
                  @click="viewMode = OfferListViewMode.list"
                >
                  {{ trans('offer.list') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="offers-list__page offers-list-page">
        <SpinnerContainer v-if="isLoading && !isLoadingNext" />
        <OfferList v-show="viewMode === OfferListViewMode.mosaic" />
        <OfferTable v-show="viewMode === OfferListViewMode.list" />
        <div v-show="hasNextPage" ref="autoloader" class="autoloader-container">
          <Spinner />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from '@components/Spinner.vue';
import SpinnerContainer from '@components/SpinnerContainer.vue';
import AddressFilter from '@components-molecules/AddressFilter.vue';
import { OfferListViewMode, useOfferListStore } from '@stores/useOfferListStore';
import { URL_OFFER_CREATE } from '@tools/routes/routes';
import { storeToRefs } from 'pinia';
import { trans } from '@elements/translation';
import OfferList from './OfferList.vue';
import OfferTable from './OfferTable.vue';
import OfferSort from './OfferSort.vue';
import StateFilter from './StateFilter.vue';
import OfferSearchTitle from './OfferSearchTitle.vue';

export default {
  components: {
    Spinner,
    OfferSearchTitle,
    StateFilter,
    SpinnerContainer,
    OfferList,
    AddressFilter,
    OfferSort,
    OfferTable,
  },
  setup() {
    const store = useOfferListStore();
    const { load } = store;
    const { isLoading, isLoadingNext, viewMode, hasNextPage } = storeToRefs(store);
    load();
    return {
      viewMode,
      isLoading,
      isLoadingNext,
      hasNextPage,
      load,
    };
  },
  data() {
    return {
      urlAddOffer: URL_OFFER_CREATE,
    };
  },
  computed: {
    OfferListViewMode() {
      return OfferListViewMode;
    },
  },
  watch: {
    isLoading(isLoading) {
      if (!isLoading) {
        this.autoloader();
      }
    },
  },
  methods: {
    trans,
    autoloader() {
      this.observer = new IntersectionObserver((entries) => {
        if (!this.isLoading && this.hasNextPage && entries[0].isIntersecting) {
          this.load(true);
        }
      });
      this.observer.observe(this.$refs.autoloader);
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@styles/variables' as *;
@use '@styles/mixins' as *;

.autoloader-container {
  background-color: $colorWhite;
  border-radius: 50%;
  padding: rem(8);
  line-height: 0;
  z-index: 2;
  text-align: center;
}

:deep(.autoloader-container svg) {
  height: rem(36);
  width: rem(36);
}
</style>
